import * as React from 'react';
import {useStyletron} from "baseui";

function getCurrencySymbol(currencyCode) {
    switch (currencyCode) {
        case 'GBP': return '£';
        case 'USD': return '$';
        case 'EUR': return '€';
        default: return currencyCode; // fallback to code if unknown
    }
}

export function PriceDisplay({ price, currency }) {
    const [css] = useStyletron();
    
    return (
        <div className={css({marginTop: '12px'})}>
            {getCurrencySymbol(currency)}{price} each
        </div>
    );
}
